var _defs, _rect, _polygon, _polygon2, _rect2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgForProgrammers = function SvgForProgrammers(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 400 400"
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "for_programmers_svg__a",
    x1: 200,
    y1: 329.96,
    x2: 200,
    y2: 99.59,
    gradientTransform: "translate(-84.25 201.42) rotate(45) scale(1 -1)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.12,
    stopColor: "#ad55fb"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6a5afb"
  })))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 110.08,
    y: 110.08,
    width: 179.84,
    height: 179.84,
    rx: 37.06,
    ry: 37.06,
    transform: "translate(-82.84 200) rotate(-45)",
    fill: "url(#for_programmers_svg__a)"
  })), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    points: "166.72 161.59 128.32 200 166.72 238.41 170.01 235.12 134.89 200 170.01 164.88 166.72 161.59",
    fill: "#fff"
  })), _polygon2 || (_polygon2 = /*#__PURE__*/React.createElement("polygon", {
    points: "233.28 161.59 229.99 164.88 265.11 200 229.99 235.12 233.28 238.41 271.68 200 233.28 161.59",
    fill: "#fff"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 138.19,
    y: 197.7,
    width: 123.61,
    height: 4.56,
    transform: "translate(-45.38 340.63) rotate(-74.82)",
    fill: "#fff"
  })));
};
export default SvgForProgrammers;